// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"ImgModal_thumbnail__2tXl2","modal":"ImgModal_modal__QeGy0","btnClose":"ImgModal_btnClose__1Vcjv"};